import LocalizedStrings from "react-localization";
import eng from "./eng.json";
import ch from "./ch.json";

const localize = new LocalizedStrings({
    "en-US": eng,
    "en": eng,
    "ch": ch
})

export default localize;